import { IMapLocation } from "@/api/AppApi/services/company/interfaces/ICompany";

export default function generateGoogleMapsLink({ lng, lat }: IMapLocation) {
  return `https://www.google.com/maps/place/${lat},${lng}`;
}
